import React from 'react';
import PropTypes from 'prop-types';
import CardInput from '../../../../common/CardInput';
import AutoHeight from '../../../../common/AutoHeight';
import PaymentList from '../containers/PaymentList';
import Modal from '../../../../common/Modal';
import { card } from '../shapes';
import SetupPaymentInfoModal from '../../../../common/SetupPaymentInfoModal';

const PaymentOptionsModal = ({
  close,
  fetching,
  setFetching,
  cards,
  setCards,
  addCard,
  removeCard,
  updateDefaultCard,
  canSelect,
  canDelete,
  canChangeDefault,
  onCardSelect,
  selectedCardId,
  customerId,
  isPaymentInfoSetup,
}) => (!isPaymentInfoSetup ? (
  <SetupPaymentInfoModal isOpen onClose={close} />
) : (
  <Modal
    title="Payment options"
    close={close}
    showCloseButton
  >
    <div className="u-ph++ u-pv+">
      <CardInput onSubmit={addCard} disabled={fetching} />
      <div className="u-mt">
        <AutoHeight>
          <PaymentList
            fetching={fetching}
            setFetching={setFetching}
            cards={cards}
            setCards={setCards}
            canDelete={canDelete}
            removeCard={removeCard}
            canChangeDefault={canChangeDefault}
            updateDefaultCard={updateDefaultCard}
            canSelect={canSelect}
            onCardSelect={onCardSelect}
            selectedCardId={selectedCardId}
            customerId={customerId}
          />
        </AutoHeight>
      </div>
    </div>
  </Modal>
));

PaymentOptionsModal.propTypes = {
  close: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired,
  setFetching: PropTypes.func.isRequired,
  cards: PropTypes.arrayOf(card).isRequired,
  setCards: PropTypes.func.isRequired,
  addCard: PropTypes.func.isRequired,
  removeCard: PropTypes.func.isRequired,
  updateDefaultCard: PropTypes.func.isRequired,
  canSelect: PropTypes.bool,
  canChangeDefault: PropTypes.bool,
  canDelete: PropTypes.bool,
  onCardSelect: PropTypes.func,
  selectedCardId: PropTypes.string,
  customerId: PropTypes.string.isRequired,
  isPaymentInfoSetup: PropTypes.bool.isRequired,
};

PaymentOptionsModal.defaultProps = {
  canSelect: false,
  canChangeDefault: false,
  canDelete: false,
  onCardSelect: () => null,
  selectedCardId: null,
};

export default PaymentOptionsModal;
